import {
  formatCurrency,
  formatDate,
  formatTime,
  getDraftTransactionType,
  parseToThousandSeperatorDecimalNumber,
  parseToThousandSeperatorWholeNumber,
} from "../../utility";
import { EMPTY_STRING, TABLE_CELL_TYPE } from "../../../constants";
import DropdownSkeleton from "../../Skeletons/DropdownSkeleton/DropdownSkeleton";

const TableCustomCellWrapper = (props) => {
  const {
    row,
    cellValue,
    cellValueKey,
    className = EMPTY_STRING,
    tableCellType = EMPTY_STRING,
    isLoadingSkeleton = () => false,
    cellValueFallBack = EMPTY_STRING,
    isApplyTextColorClassesForValues = false, // 0 = default color, < 0 red color, > 0 purple color
    children, //custom cell content can be passed as children, but make sure to handle text truncation in the custom component
  } = props;
  let formattedCellValue = cellValue || (row && row[cellValueKey]);
  const rawCellValue = Number(formattedCellValue); // unformatted value (without $ appended or date formatting) used for applying conditional text color classes

  // Convert cell value to date and time if based on the cell type specified.
  if (tableCellType === TABLE_CELL_TYPE.DATE) {
    formattedCellValue = formatDate(formattedCellValue);
  } else if (tableCellType === TABLE_CELL_TYPE.TIME) {
    formattedCellValue = formatTime(formattedCellValue);
  } else if (tableCellType === TABLE_CELL_TYPE.DRAFT_TRANSACTION_TYPE) {
    formattedCellValue = getDraftTransactionType(formattedCellValue);
  } else if (tableCellType === TABLE_CELL_TYPE.DOLLAR_AMOUNT) {
    formattedCellValue = formatCurrency(formattedCellValue || 0);
  } else if (tableCellType === TABLE_CELL_TYPE.WHOLE_NUMBER) {
    formattedCellValue =
      parseToThousandSeperatorWholeNumber(formattedCellValue);
  }

  // Case 1: render loading skeletion
  if (isLoadingSkeleton(row)) {
    return <DropdownSkeleton width="5em" height="1.5em" />;
  }
  //Case 2: if children are passed means user passed the custom cell component. All props will be ignored in this case. Means we will ignore all the (truncation, text color, value conversion etc).
  else if (props.children) {
    return children;
  }
  // Case 3: apply all props based on the value passed
  else {
    return (
      <span
        className={`text-truncate 
                  ${
                    isApplyTextColorClassesForValues &&
                    (rawCellValue < 0
                      ? "text-red"
                      : rawCellValue > 0
                      ? "text-purple"
                      : EMPTY_STRING)
                  }
                ${className}`}
      >
        {formattedCellValue ?? cellValueFallBack}
      </span>
    );
  }
};

export default TableCustomCellWrapper;
